import React from "react";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Gallery from "@/components/sections/Gallery";
import TrustedBy from "@/components/sections/TrustedBy";
import MaintenancePlan from "@/components/sections/MaintenancePlan";
import BookingSection from "@/components/sections/BookingSection";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";
import WhatsAppButton from "@/components/sections/WhatsAppButton";

export default function Landing() {
  return (
    <div className="relative bg-[#0A0A0A] text-white min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <TrustedBy />
        <MaintenancePlan />
        <BookingSection />
        <FAQ />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
